import type { Messages } from "@prop/i18n";
import type en from "../en/legal";

export default {
  updated: "Версия 1.0 · действует с 31 октября 2026 г.",
  contents: "Содержание",
  documents: "Юридические документы",
  questions: "Вопросы по этим документам: hello@fundedlime.com",
  nav: {
    terms: "Условия использования",
    refunds: "Платежи и возвраты",
    payouts: "Политика выплат",
    prohibited: "Запрещённые практики",
    aml: "AML и KYC",
    privacy: "Политика конфиденциальности",
    cookies: "Политика cookie",
    risk: "Раскрытие рисков",
    execution: "Политика исполнения",
  },
  consent: {
    title: "Cookie",
    body: "Мы используем только cookie, необходимые для работы и безопасности сайта. Необязательные (аналитика, маркетинг, график TradingView) работают, только если вы их разрешите.",
    policy: "Политика cookie",
    acceptAll: "Принять все",
    necessaryOnly: "Только необходимые",
    settings: "Настройки",
    save: "Сохранить выбор",
    close: "Закрыть",
    open: "Настройки cookie",
    always: "Всегда включены",
    notUsed: "Сейчас не используются",
    necessary: { name: "Строго необходимые", note: "Вход, безопасность, защита от мошенничества и запоминание этого выбора. Отключить нельзя." },
    analytics: { name: "Аналитика", note: "Статистика посещений для улучшения сайта. Сейчас мы её не используем; если добавим, она будет работать только при включённой категории." },
    marketing: { name: "Маркетинг", note: "Реклама и ретаргетинг. Сейчас мы их не используем; если добавим, они будут работать только при включённой категории." },
    external: { name: "Внешний контент", note: "Дополнительный график TradingView в терминале. TradingView получает ваш IP-адрес и может устанавливать собственные cookie." },
  },
  tvGate: {
    title: "График TradingView",
    body: "Этот вид загружается с TradingView, который получает ваш IP-адрес и может устанавливать собственные cookie.",
    load: "Загрузить TradingView",
    policy: "Политика cookie",
  },
} satisfies Messages<typeof en>;
